import type { Virtualizer } from '@tanstack/react-virtual';
import clsx from "clsx";
import type { FunctionComponent } from "react";
import type { PropsWithChildren } from "react";

type TableWrapperProps = PropsWithChildren & {
    className?: string;
    rounded?: boolean;
    scrollContainerRef?: React.RefObject<HTMLDivElement>;
    virtualizer?: Virtualizer<HTMLDivElement, Element>;
};

const TableWrapper: FunctionComponent<TableWrapperProps> = ({
    className,
    children,
    rounded,
    scrollContainerRef,
    virtualizer
}) => {
    // For virtualized tables, we need a different structure
    if (virtualizer) {
        if (rounded) {
            return (
                <div className="inline-flex max-h-full w-full rounded-lg bg-white py-3 shadow-sm">
                    <div
                        ref={scrollContainerRef}
                        className="relative block max-h-full w-full overflow-y-auto"
                    >
                        <table className={clsx("w-full bg-white", className)}>
                            {children}
                        </table>
                    </div>
                </div>
            );
        }

        return (
            <div
                ref={scrollContainerRef}
                className="relative block max-h-full overflow-y-auto"
            >
                <table className={clsx("w-full bg-white", className)}>
                    {children}
                </table>
            </div>
        );
    }

    // Non-virtualized tables keep the original structure
    if (rounded) {
        return (
            <div className="inline-flex max-h-full w-full rounded-lg bg-white py-3 shadow-sm">
                <div className="block max-h-full w-full overflow-y-auto">
                    <table className={clsx("relative size-full max-w-full bg-white", className)}>
                        {children}
                    </table>
                </div>
            </div>
        );
    }

    return (
        <div className="block max-h-full overflow-y-auto">
            <table
                className={clsx("relative size-full max-w-full overflow-y-auto bg-white", className)}
            >
                {children}
            </table>
        </div>
    );
};

export default TableWrapper;